module.exports = __webpack_public_path__ + "img/ИФ-1(А)-052-m.3a81b5bc.png";